import { render, staticRenderFns } from "./company-table.vue?vue&type=template&id=c0e1cd0e&scoped=true&"
import script from "./company-table.vue?vue&type=script&lang=js&"
export * from "./company-table.vue?vue&type=script&lang=js&"
import style0 from "./company-table.vue?vue&type=style&index=0&id=c0e1cd0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e1cd0e",
  null
  
)

export default component.exports